/**
 * Fechas de `<input type="date">` en hora LOCAL.
 *
 * `new Date().toISOString().slice(0, 10)` da la fecha en UTC: en Chile,
 * desde las 21:00 (20:00 en verano) devuelve el día siguiente. Para un
 * input de fecha siempre se quiere el día del calendario de quien opera.
 *
 * Lo usan cortes, contratos y atenciones.
 */
export function fechaLocalISO(d: Date): string {
  const a = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const dia = String(d.getDate()).padStart(2, "0");
  return `${a}-${m}-${dia}`;
}

/** Hoy, `YYYY-MM-DD`, en la zona horaria del navegador. */
export function hoyLocalISO(): string {
  return fechaLocalISO(new Date());
}

/** `YYYY-MM-DD` → `Date` a medianoche local (sin corrimiento por UTC). */
export function parseFechaLocal(iso: string): Date {
  const [a, m, d] = iso.slice(0, 10).split("-").map(Number);
  return new Date(a ?? 1970, (m ?? 1) - 1, d ?? 1);
}

/**
 * `15-10-2026` desde `2026-10-15` (o un ISO con hora): el formato de fecha
 * de la app, dd-mm-aaaa. No pasa por `Date`, así que no corre de día por
 * zona horaria.
 */
export function fechaDMA(iso: string | null | undefined): string {
  if (!iso) return "—";
  const [a, m, d] = iso.slice(0, 10).split("-");
  return `${d}-${m}-${a}`;
}

/** Suma `n` días hábiles (lunes a viernes) a `desde`. No descuenta feriados. */
export function sumarDiasHabiles(desde: Date, n: number): Date {
  const d = new Date(desde.getFullYear(), desde.getMonth(), desde.getDate());
  let restantes = n;
  while (restantes > 0) {
    d.setDate(d.getDate() + 1);
    const dow = d.getDay();
    if (dow !== 0 && dow !== 6) restantes -= 1;
  }
  return d;
}
